<template>
  <div id="app" class="min-h-screen theme-bg">
    <router-view></router-view>
  </div>
</template>

<script>
import { ThemeManager } from '@/utils'

export default {
  name: 'App',
  created() {
    // 在应用启动时应用保存的主题设置
    const savedTheme = ThemeManager.getCurrentTheme();
    if (savedTheme) {
      ThemeManager.applyTheme(savedTheme);
    }
  }
}
</script>

<style>
@import './assets/css/tailwind.css';

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--text-primary);
}

.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s;
}
.page-enter,
.page-leave-to {
  opacity: 0;
}

/* 全局导航栏激活样式 */
.nav-active {
  color: var(--accent-color) !important;
}

.nav-active p {
  color: var(--primary-dark) !important;
}

.nav-active .svg-inline--fa {
  color: var(--primary-color) !important;
}
</style> 